<template>
  <div class="payment-options">
    <RefundPopup
      :show="showRefundPopup"
      @closeRefundModal="showRefundPopup = false"
      :txId="qrData?.id"
      :currency="qrData?.currency"
      :receivedAmount="paymentStatus?.recievedAmount"
    />
    <back-button-custom
      title="Back"
      v-if="
        cryptoWalletStep === 1 && !isContinuedTransaction && enableWalletConnect
      "
      @click="() => $emit('changePaymentType', 'WALLET')"
    />
    <template v-if="responseReceived && prevTxStatus != 'partial'">
      <template v-if="cryptoWalletStep === 1">
        <FirstStep
          :walletOptions="walletOptions"
          @exchangeCoinChange="exchangeCoinChange"
          @changePaymentType="changePaymentType"
          @searchData="searchDataUpdated"
          :style="isContinuedTransaction ? { 'pointer-events': 'none' } : {}"
        />

        <!--Do not show in case of Preview -->
      </template>
      <template v-else-if="cryptoWalletStep === 2">
        <SecondStep
          @backToPreviousStep="backToPreviousStep"
          :anyWalletCoin="anyWalletCoin"
          :qrData="qrData"
          :payableData="payableData"
          :currencies="currencies"
          :anyWalletError="anyWalletError"
          :convertedCart="convertedCart"
          :displayCurrency="displayCurrency"
          :isPreview="isPreview"
          :isCodeExpired="isCodeExpired"
          :isContinuedTransaction="isContinuedTransaction"
        />
      </template>
    </template>
    <template v-else>
      <div class="cs-payment__partial-payment text-center">
        <vue-qr
          :style="isCodeExpired ? { opacity: 0.1 } : {}"
          v-if="qrData && qrData.meta && !forceRefund"
          :text="qrData.meta ? qrData.meta.qrString : ''"
          class="cs-qrcode"
        />
        <div :class="!qrData || !qrData.meta ? 'disable-events' : ''">
          <div class="" v-if="qrData && qrData.meta && !forceRefund">
            <div
              class="cs-qrcopybox mx-auto d-flex justify-content-between align-items-center"
            >
              <span class="ml-2 wallet-address">
                {{
                  qrData.meta && qrData.meta.receiverAddress
                    ? ShortText(qrData.meta.receiverAddress, 10)
                    : ""
                }}</span
              >
              <div
                v-if="!isCodeExpired"
                v-clipboard="qrData.meta.receiverAddress"
                v-clipboard:success="ClipboardSuccessHandler"
                @click.prevent="handleCopyClick"
                class="btn copy-btn"
              >
                <img
                  v-if="!isCopied"
                  src="@/assets/img/Copy_alt.svg"
                  alt="copy"
                />
                <span v-if="isCopied" class="copied-message">Copied</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center" />
        </div>
        <div class="expiry-overlay-box">
          <div class="expiry-overlay" v-if="isCodeExpired">
            <h5>{{ $t("qr-expired.title") }}</h5>
            <p>{{ $t("qr-expired.desc1") }}</p>
            <p>
              {{ $t("qr-expired.description") }}
              <a :href="shopperUrl" target="_blank">Portal here</a>.
            </p>
          </div>
        </div>

        <div
          class="d-flex justify-content-center py-2 my-2 align-items-center"
          v-if="!forceRefund"
        >
          <span>
            <img src="@/assets/img/orange-warning.svg" />
          </span>
          <small>Partial payment received! </small>
          <img
            src="@/assets/img/info_blue.svg"
            id="titlePartial"
            alt="info"
            class="ml-1"
          />
          <b-tooltip
            target="titlePartial"
            placement="top"
            class="my-tooltip-class"
          >
            Partial payment was sent or <br />
            Either USD was sent instead of {{ paymentStatus.currency }} or<br />
            Blockchain network fee (gas fee) was high.
          </b-tooltip>
        </div>
        <div
          class="d-flex justify-content-center py-2 my-2 align-items-center"
          v-else
        >
          <small class="cs-payment__error font-size-15"
            >{{ $t("payment.paymentIncomplete") }}
          </small>
        </div>
        <small v-if="!forceRefund">
          <p v-if="!isCodeExpired">To complete your order</p>
          <p v-if="!isCodeExpired">{{ $t("qr-code.scan-code-partial") }}</p>
          <h5 style="color: #000">
            {{
              (
                Number(qrData.totalAmount) -
                Number(paymentStatus.recievedAmount)
              ).toFixed(8)
            }}
            {{ paymentStatus.currency }}
          </h5>
        </small>
        <small v-if="forceRefund" class="cs-payment__refund_link_desc">{{
          $t("payment.refundDesc")
        }}</small>
        <button
          v-if="forceRefund"
          class="cs-payment__refund_link"
          @click="showRefundModal()"
        >
          {{ $t("payment.requestRefund") }}
        </button>
      </div>
    </template>
    <small class="cs-payment__error" v-if="anyWalletError">
      {{ anyWalletError }}
    </small>
    <div
      class="cs-payment mt-2 mb-1"
      v-if="
        paymentStatus &&
        Object.keys(paymentStatus).length &&
        paymentStatus.txStatus !== 'pending'
      "
    >
      <div
        class="cs-payment__payment-processed"
        v-if="paymentStatus && paymentStatus.txStatus === 'completed'"
      >
        <div>
          <img src="@/assets/img/verify.svg" />
        </div>
        <small>
          {{ $t("unauth-payment.payment-processed") }}
        </small>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
/* eslint-disable global-require */

/* eslint-disable vue/no-side-effects-in-computed-properties */

import FirstStep from "@/components/CryptoWallet/FirstStep.vue";
import { mapGetters } from "vuex";
import {
  GET_SETTINGS,
  PURCHASE_EXTERNAL,
  GET_EXTERNAL_STATUS,
  GET_EXTERNAL_STATUS_EVENT,
  CURRENCY_COMPARE,
  USDT,
  ETH,
  ETHER,
  SET_TAB,
  T_ETHER,
  GET_PAYABLE_AMOUNT,
  PARTIAL_TX,
  USER_TRACK_EVENTS,
  EXTERNAL_STATUS_TIMER,
  SET_RESULT_PAGE_DATA,
} from "@/store/modules/user/consts";

import websocket from "@/utils/socket.connections";
import Web3 from "web3";
// import Loading from '@/components/Loading.vue';
import CustomCarousel from "../views/customCarousel.vue";
import CustomButton from "../views/customButton.vue";
import { isUSD } from "../utils/helper";
import { DEFAULT_CURRENCY } from "../utils/stringconsts";
import { transactionSourceEnum } from "../store/modules/user/enums";
import config, { enableWalletConnect } from "../utils/config";
import SecondStep from "./CryptoWallet/SecondStep.vue";
import { CONTINUED_TRANSACTION } from "@/utils/event.constants";
import RefundPopup from "@/components/RefundPopup.vue";
export default {
  components: {
    FirstStep,
    CustomButton,
    CustomCarousel,
    SecondStep,
    RefundPopup,
    // Loading,
  },
  props: {
    isPreview: Boolean,
    selectedTab: Boolean,
    isContinuedTransaction: Boolean,
    navigateToPreviousStep: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      shopperUrl: process.env.VUE_APP_SHOPPER_URL,
      showTimerInfo: false,
      countdownTimer: null,
      resolvingCurrencyResponse: false,
      metamaskSenderAccount: [],
      // checkingPaymentpartial: false,
      isMetaMaskOpen: false,
      isMetaMaskInstalled: typeof window.ethereum !== "undefined",
      convertedCart: {},
      anyWalletError: "",
      isCodeExpired: false,
      countdown: {
        totalMilliseconds: 0,
        minutes: 0,
        seconds: 0,
        limit: config.countdownMilliseconds,
      },
      qrData: {},
      anyWalletCoin: {},
      expand: false,
      externalWalletCalled: false,
      // checkingPayment: false,
      paymentStatus: {},
      count: 0,
      externalCount: 0,
      searchData: "",
      purchaseInterval: null,
      receivedAmount: null,
      titlePartial:
        "Partial payment was sent or <br> Either USD was sent instead of BTC or </br>Blockchain network fee (gas fee) was high",
      resultData2: {
        // eslint-disable-next-line
        icon: require("@/assets/img/success.svg"),
        title: this.$t("result.success"),
        description: this.$t("result.success-text"),
      },
      time: null,
      step1: true,
      step2: false,
      step3: false,
      infoText: [
        {
          key: 1,
          text: "If you use an exchange, you dont have to scan the QR code to pay. You only have to connect your exchange account once and you can use it at any store that uses RocketFuel. Did you know - you can",
        },
        {
          key: 2,
          text: "Did you know - you can create a RocketFuel account and access all your purchases in one place",
        },
        {
          key: 3,
          text: "Your transaction is taking longer than expected to confirm on the blockchain. You can leave this view or close the browser. We will email you when the transaction is confirmed on the blockchain.",
        },
      ],
      payableData: {},
      curCntValue: 0,
      timerFunction: null,
      // partialCounts: 0,
      defultWalletCoin: [],
      timerInfoMsg: this.$t("qr-wallet.timer-info"),
      isCopied: false,
      showRefundPopup: false,
      prevTxStatus: "",
    };
  },
  setup() {
    return { enableWalletConnect };
  },
  destroyed() {
    this.clearCountdown();
  },
  computed: {
    ...mapGetters({
      isGuestUser: "auth/isGuestUser",
      cart: "user/cart",
      settings: "user/settings",
      displayCurrency: "user/displayCurrency",
      currencies: "user/currencies",
      marketInfo: "user/marketInfo",
      userInfo: "user/userInfo",
      socket: "user/getSocketResponse",
      paymentCompleted: "auth/paymentCompleted",
      cryptoWalletStep: "user/getCryptoWalletStep",
    }),
    forceRefund() {
      return this.marketInfo?.forceRefund || false;
    },
    cartConversionData() {
      return { cart: this.cart, settings: this.settings };
    },
    walletOptions() {
      if (this.currencies && this.currencies.length) {
        const walletOpt = this.getCurrencies(this.currencies);
        // const currencyuser = this.$store.dispatch(`user/${GET_SETTINGS}`);
        // const defaultWalletCoin = () => {
        //   currencyuser.then((a) => {
        //     if (
        //       !this.anyWalletCoin ||
        //       !Object.keys(this.anyWalletCoin).length
        //     ) {
        //       // eslint-disable-next-line prefer-destructuring
        //       if (a.accountId != null) {
        //         this.defultWalletCoin = walletOpt.filter(
        //           (obj) => obj.currency === a.accountId
        //         );
        //         this.anyWalletCoin = { ...this.defultWalletCoin[0] };
        //         if (
        //           !this.anyWalletCoin ||
        //           !Object.keys(this.anyWalletCoin).length
        //         ) {
        //           this.anyWalletCoin = { ...walletOpt[0] };
        //         }
        //       } else {
        //         this.anyWalletCoin = { ...walletOpt[0] };
        //       }
        //     }
        //   });
        // };
        // defaultWalletCoin();
        return walletOpt;
      }
      return [];
    },
    isSocketConnected() {
      return websocket.connected();
    },
    responseReceived() {
      if (this.paymentStatus && this.paymentStatus.txStatus === "partial") {
        return false;
      }
      return true;
    },
  },
  mounted() {
    if (this.purchaseInterval) {
      clearInterval(this.purchaseInterval);
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    this.$store.commit(`user/setCryptoWalletStep`, 1);
    window.EventBus.on(`startCountdown`, () => {
      if (!this.countdownTimer) {
        this.startCountdown();
      }
    });
    window.EventBus.on(CONTINUED_TRANSACTION, (data) => {
      this.$store.commit(`user/setCryptoWalletStep`, 2);
      this.setPreviousTxDetails(data);
    });
  },
  watch: {
    navigateToPreviousStep(newVal) {
      if (newVal === true) {
        this.backToPreviousStep();
      }
    },
    cryptoWalletStep() {
      if (this.cryptoWalletStep === 1) {
        this.clearCountdown();
      }
    },
    "paymentStatus.txStatus": {
      handler(val) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
        setTimeout(() => {
          this.startCountdown();
        }, 1000);
      },
    },
    "countdown.totalMilliseconds"(val) {
      if (val < 1000) {
        if (this?.paymentStatus?.txStatus === "partial" && this.forceRefund) {
          this.isCodeExpired = false;
        } else {
          this.isCodeExpired = true;
        }
        clearInterval(this.countdownTimer);
      }
    },
    socket: {
      handler(val) {
        if (val.txStatus === "completed") {
          this.validateResponse(val, false);
          websocket.disconnect();
        }
      },
    },
    selectedTab: {
      handler(val) {
        if (val) {
          this.curCntValue = 0;
          // this.startTimer();
        } else {
          clearInterval(this.timerFunction);
        }
      },
    },
    qrData: {
      handler(val) {
        if (val && Object.keys(val).length) {
          this.initalizeWebSockets();
          if (this.time) {
            clearTimeout(this.time);
          }
        }
      },
    },
    cartConversionData: {
      async handler(newVal) {
        let conversionRate = 1;
        let usdEquivalentRate = 1;
        if (newVal.settings?.displayCurrency !== undefined && newVal.cart) {
          // some clients do not pass cart currency
          // eslint-disable-next-line no-param-reassign
          newVal.cart.currency =
            newVal.cart?.currency !== undefined ? newVal.cart?.currency : "USD";
          // Perform conversion if the currency are different
          if (
            newVal.settings?.displayCurrency.toUpperCase() !==
            newVal.cart?.currency.toUpperCase()
          ) {
            conversionRate = await this.getCurrConverRate(
              newVal.cart?.currency,
              newVal.settings?.displayCurrency
            );
            usdEquivalentRate = conversionRate;
          }
          // need USD for conversion to crypto (Base currency)
          if (
            !isUSD(newVal.cart?.currency) &&
            !isUSD(newVal.settings?.displayCurrency)
          ) {
            usdEquivalentRate = await this.getCurrConverRate(
              newVal.cart?.currency,
              DEFAULT_CURRENCY
            );
          } else if (isUSD(newVal.cart?.currency)) {
            usdEquivalentRate = 1;
          }
          this.convertedCart = newVal.cart;
          this.convertedCart.usdEquivalentRate = usdEquivalentRate;
          this.convertedCart.conversionRate = conversionRate;
          this.convertedCart.displayCurrency = newVal.settings?.isUserConfigured
            ? newVal.settings?.displayCurrency.toUpperCase()
            : newVal.cart?.currency.toUpperCase();
        }
        this.getPayableData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    showRefundModal() {
      // Log Activity
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        serviceName: "Iframeless",
        moduleInfo: {
          current: "CryptoWallet",
          activity: "Refund Request button clicked.",
          storeName: this.marketInfo?.merchant?.shopData?.companyName || "",
          shopper: this.userInfo.email || "",
        },
      });
      this.showRefundPopup = true;
    },
    handleCopyClick(event) {
      // Prevent the default click behavior
      event.preventDefault();

      const isSuccess = true;

      if (isSuccess) {
        // Set isCopied to true to show the "Copied" message
        this.isCopied = true;

        // Reset isCopied after a delay (e.g., 2 seconds)
        setTimeout(() => {
          this.isCopied = false;
        }, 2000);
      }
    },
    changePaymentType(val) {
      this.$emit("changePaymentType", val);
    },
    ClipboardSuccessHandler(value) {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        serviceName: "Iframe",
        moduleInfo: {
          current: "Crypto Wallet tab",
          activity: `clicked on copy button, Wallet Address copied.`,
        },
      });
    },
    ShortText(text, size) {
      if (!text) {
        return `-`;
      }
      if (size) {
        return `${text.slice(0, size)}...${text.slice(-size)}`;
      }
      if (text.length > 25 && !size) {
        return `${text.slice(0, 25)}...`;
      }
      return text;
    },
    setPreviousTxDetails(data) {
      this.$refs?.loader?.hide();
      this.qrData = data;
      this.anyWalletCoin = this.walletOptions.find(
        (val) => val.currency === this.qrData.currency
      );
      this.startTimer();
      setTimeout(() => {
        this.startCountdown();
      }, 400);
    },
    convertNumberToTwoDigit(number) {
      return number.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    },
    startCountdown() {
      let that = this;
      let countDownDate = new Date().getTime() + 15 * 60 * 1000;
      this.countdownTimer = setInterval(function () {
        let now = new Date().getTime();
        let distance = countDownDate - now;
        // let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = that.convertNumberToTwoDigit(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        );
        let seconds = that.convertNumberToTwoDigit(
          Math.floor((distance % (1000 * 60)) / 1000)
        );

        that.$set(that.countdown, "minutes", minutes);
        that.$set(that.countdown, "seconds", seconds);
        that.$set(that.countdown, "totalMilliseconds", distance);
        that.$set(that.countdown, "limit", config.countdownMilliseconds);
      }, 1000);
    },
    searchDataUpdated(val) {
      this.searchData = val;
    },
    clearCountdown() {
      this.$set(this.countdown, "minutes", null);
      this.$set(this.countdown, "seconds", null);
      this.$set(this.countdown, "totalMilliseconds", null);
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    },
    backToPreviousStep() {
      this.isCodeExpired = false;
      this.anyWalletError = "";
      // added as on change currency the currency was not changed
      this.anyWalletCoin = {};
      this.$store.commit(`user/setCryptoWalletStep`, 1);
      this.$DbStorage.removeItem('currentSessionInstructions');
      this.qrData = {};
      this.clearCountdown();
      // this.checkingPayment = false;
    },
    async startTimer() {
      if (this.curCntValue % EXTERNAL_STATUS_TIMER === 0 && this.qrData.id) {
        this.initiateSSE(1);
      }
      this.curCntValue += 1;
    },
    // checkPatialCount() {
    //   if (this.partialCounts >= 3) {
    //     return true;
    //   }
    //   return false;
    // },
    async getPayableData() {
      if (!this.anyWalletCoin.currency || !this.cart.uuid) {
        return;
      }
      try {
        const resp = await this.$store.dispatch(`user/${GET_PAYABLE_AMOUNT}`, {
          cc: this.anyWalletCoin.currency,
          invoice: this.cart.uuid,
        });

        this.payableData = resp;
      } catch (err) {
        //todo
      }
    },
    async getMetaCurrencyName() {
      switch (this.anyWalletCoin.currency) {
        case USDT:
          return T_ETHER;
        // return `${Web3.utils.toWei(this.qrData.amount, T_ETHER)}`;
        case ETH:
        default:
          return ETHER;
        // return `0x${Web3.utils.toBN(Web3.utils.toWei(this.qrData.amount, ETHER))
        // .toString(16)}`;
      }
    },
    initalizeWebSockets() {
      if (websocket.connected()) {
        // this.checkingPayment = true;
        websocket.subscribe(this.qrData.id);
      }
    },
    exit() {
      this.notifyParentWindow({
        type: "rocketfuel_iframe_close",
        paymentCompleted: "auth/paymentCompleted",
      });
    },
    async checkForExternalPurchase() {
      if (!this.isPreview && !this.externalWalletCalled) {
        this.callExternalPurchase();
      }
    },
    async callExternalPurchase() {
      try {
        this.qrData = {};
        this.externalWalletCalled = true;
        let conversionRate = 1;
        const usdEquivalentRate = 1;
        let convertedCart = {};
        if (this.settings?.displayCurrency !== undefined && this.cart) {
          // eslint-disable-next-line no-param-reassign
          this.cart.currency =
            this.cart?.currency !== undefined ? this.cart?.currency : "USD";
          // Perform conversion if the currency are different
          if (
            this.settings?.displayCurrency.toUpperCase() !==
            this.cart?.currency.toUpperCase()
          ) {
            conversionRate = await this.getCurrConverRate(
              this.cart?.currency,
              this.settings?.displayCurrency
            );
          }
          convertedCart = this.cart;
          convertedCart.usdEquivalentRate = usdEquivalentRate;
          convertedCart.conversionRate = conversionRate;
          convertedCart.displayCurrency = this.settings?.isUserConfigured
            ? this.settings?.displayCurrency.toUpperCase()
            : this.cart?.currency.toUpperCase();
        }
        if (
          !convertedCart ||
          !convertedCart.cart ||
          !convertedCart.amount ||
          !this.anyWalletCoin.currency
        ) {
          this.externalWalletCalled = false;
          this.purchaseInterval = setTimeout(() => {
            this.checkForExternalPurchase();
          }, config.intervalForExternalPurchase);
          return;
        }
        const res = await this.$store.dispatch(`user/${PURCHASE_EXTERNAL}`, {
          encrypted: this.Encrypt({
            clientId: convertedCart.merchant_id,
            amount: convertedCart.amount,
            currency: this.anyWalletCoin.currency,
            chainNetwork: this.anyWalletCoin.chainNetwork,
            cart: convertedCart.cart,
            shippingAddress: this.cart.shippingAddress
              ? this.cart.shippingAddress
              : null,
            merchantStoreCurrency: this.cart.currency,
            offerId: convertedCart.order,
            confirmation: convertedCart.encrypted || "",
            hostedPageId: convertedCart.uuid || "",
          }),
          source: transactionSourceEnum.WALLET,
        });
        this.resolvingCurrencyResponse = false;
        if (res.status === "ok") {
          if (this.purchaseInterval) {
            clearInterval(this.purchaseInterval);
          }
          this.anyWalletError = "";
          this.qrData = res.response;
          this.initiateSSE(0);
        } else if (res.status === "error") {
          this.anyWalletError = res.response;
          this.externalCount += 1;
          if (this.externalCount < 3) {
            this.purchaseInterval = setTimeout(() => {
              this.checkForExternalPurchase();
            }, config.intervalForExternalPurchase);
          }
        }
        this.initiatePayment();
        this.externalWalletCalled = false;
      } catch (e) {
        this.externalWalletCalled = false;
        this.externalCount += 1;
        if (this.externalCount < 3) {
          this.purchaseInterval = setTimeout(() => {
            this.checkForExternalPurchase();
          }, config.intervalForExternalPurchase);
        }
      }
    },
    exchangeCoinChange(value) {
      this.curCntValue = 0;
      this.resolvingCurrencyResponse = true;
      this.anyWalletCoin = value;
      this.checkForExternalPurchase();
      this.getPayableData();
      this.searchData = "";
      this.$store.commit(`user/setCryptoWalletStep`, 2);
      this.isCodeExpired = false;
      if (this.$DbStorage.getItem("doNotRepeatInstructions") === "true") {
        this.startCountdown();
      }
      this.$emit("anyWalletCoin", this.anyWalletCoin);
    },
    closerInfo() {
      this.step1 = true;
    },
    initiatePayment() {
      this.$emit("paymentConfirmed");
    },
    async validatePayment() {
      if (this.cryptoWalletStep === 1) return;
      this.count += 1;
      // this.checkingPayment = true;
      this.closerInfo();
      // if (flag === 'partial') {
      //   this.checkingPaymentpartial = true;
      // }
      try {
        const encrypt = Buffer.from(
          this.Encrypt({ txId: this.qrData.id })
        ).toString("base64");
        // clearInterval(this.timerFunction);
        const resp = await this.$store.dispatch(
          `user/${GET_EXTERNAL_STATUS_EVENT}`,
          { encrypt }
        );

        if (resp?.data?.result?.responseObj) {
          this.paymentStatus = resp?.data?.result?.responseObj;
        }
        this.validateResponse(resp?.data?.result?.responseObj, true);
        return;
      } catch (err) {
        console.log(err);
        this.addTimeoutPaymentCheck();
      }
    },
    addTimeoutPaymentCheck() {
      const that = this;
      this.time = setTimeout(() => {
        if (that.count <= 300) {
          that.validatePayment();
        } else {
          clearTimeout(this.time);
        }
      }, config.intervalForExternalPurchase);
    },
    async validateResponse(data, isvalidate) {
      if (!data || !data?.txStatus) {
        if (isvalidate) {
          this.addTimeoutPaymentCheck();
        }
        return;
      }
      this.paymentStatus = data;
      switch (data.txStatus) {
        case "pending": {
          if (isvalidate) {
            this.addTimeoutPaymentCheck();
          }
          break;
        }
        case "partial": {
          this.prevTxStatus = "partial";
          if (data.disablePartialSuccess && !this.forceRefund) {
            await this.$store.commit("auth/changePaymentCompleted");
            this.paymentStatus = data;
            // setTimeout(() => {
            this.complete(this.paymentStatus);
            // }, 4000);
          } else {
            setTimeout(() => {
              this.addTimeoutPaymentCheck();
              this.$emit(`cryptoPaymentStatus`, data.txStatus);
              setTimeout(() => {
                this.$emit(`setLoader`, false);
              }, 1000);
              if (this.qrData?.meta?.qrString && data?.qrString) {
                this.qrData.meta.qrString = data.qrString;
              }
            }, 4000);
            if (this.forceRefund) {
              clearTimeout(this.time);
              this.clearCountdown();
            }
          }
          break;
        }
        case "completed": {
          // this.$store.commit(`user/setCryptoWalletStep`, 1);
          await this.$store.commit("auth/changePaymentCompleted");
          setTimeout(() => {
            this.complete(this.paymentStatus);
          }, 4000);
          break;
        }
        default:
          break;
      }
    },
    getCurrencies(currencies) {
      let walletOpt = currencies.filter(
        (val) => val.isEnabled && !val.isFiat && val.isPayment
      );
      walletOpt = walletOpt.map((val) => ({
        name: val.fullTitle,
        currency: val.id,
        logo: val.logo,
        fasterConfirmation: val.fasterConfirmation,
        chainNetwork: val["chains.network"],
        chainsNetworkLogo: val["chains.networkLogo"],
        chainsNetworkFullTitle: val["chains.networkFullTitle"],
        networkMsg: val.networkMsg,
      }));
      if (this.searchData && this.searchData.length) {
        walletOpt = walletOpt.filter(
          (val) =>
            val.name.toLowerCase().includes(this.searchData.toLowerCase()) ||
            val.currency.toLowerCase().includes(this.searchData.toLowerCase())
        );
      }
      return walletOpt;
    },
    async getCurrConverRate(from, to) {
      const res = await this.$store.dispatch(`user/${CURRENCY_COMPARE}`, {
        to: to.toUpperCase(),
        from: from.toUpperCase(),
        source: transactionSourceEnum.WALLET,
      });
      if (res.status === "ok") {
        return res[to.toUpperCase()];
      }
      return 1;
    },
    async initiateSSE(isReOpen) {
      try {
        const payload = {
          txId: this.qrData.id,
          source: transactionSourceEnum.WALLET,
          jobTrack: true
        };
        const resp = await this.$store.dispatch(
          `user/${GET_EXTERNAL_STATUS}`,
          payload
        );
        if (!resp?.data?.result?.success) {
          this.retrySSE();  
        }
        else {
          if (isReOpen) {
            this.validatePayment();
          } else {
            this.addTimeoutPaymentCheck();
          }          
        }
        return;
      } catch (err) {
        console.log(err);
        this.retrySSE();
      }
    },
    async retrySSE() {
      console.log('Unable to complete initiateSSE, retrying...');
      setTimeout(() => {
        this.initiateSSE(0);
      }, 5000);
    },
    async complete(paymentStatus) {
      this.anyWalletError = "";
      this.searchData = "";
      if (!this.anyWalletError) {
        this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
          serviceName: "Iframe",
          moduleInfo: {
            current: "Wallet",
            activity: "Wallet Payment Success",
            meta: {
              name: this.anyWalletCoin.currency,
            },
          },
        });
        this.$emit("setLoader", true);
        await this.$store.commit("user/clearCart");
        this.notifyParentWindow({
          type: "rocketfuel_result_ok",
          response: {
            paymentMode: "Wallet",
            status: paymentStatus.txStatus,
            recievedAmount: paymentStatus.recievedAmount,
            currency: paymentStatus.currency,
          },
          paymentCompleted: this.paymentCompleted,
        });
        this.$store.dispatch(`user/${SET_TAB}`, "");
        this.resultData2.paymentData = paymentStatus;
        this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, this.resultData2);
        if (this.userInfo && this.userInfo.ssoStatus) {
          this.$router.push({ name: "Thank" });
        } else {
          this.$router.push({
            name: "Result",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-options {
  background: #fff;

  //padding-top: 20px;
  // margin-bottom: 40px;
  .link-class {
    padding: 8px 5px !important;
    font-size: 12px;
    white-space: nowrap;
    position: relative;
    font-weight: 500;
    border-left: 1px solid #ededee !important;
    border-right: 1px solid #ededee !important;

    &:hover {
      border-bottom: none !important;
    }
  }

  h2 {
    font-size: 15px;
    line-height: 25px;
    color: $grey;
    font-weight: 600;
    margin: 0;
    margin-bottom: 8px;
  }

  .payment-option-inner {
    border-radius: 6px;
    background: #ededee;

    .tab-data__wrapper {
      background-color: #fff;

      .tab-data__content {
        border: 1px solid #ededee;
        border-radius: 4px;
        padding: 12px;
        border-top: none;
      }
    }
  }
}

.countdown-info {
  ul {
    padding-left: 25px;
  }

  .msg {
    font-weight: 400;
    font-size: 12px;
    color: #000000;
    position: relative;
  }

  #info-tooltip {
    position: relative;
    line-height: 26px;
    font-size: 14px;
    font-weight: 400;
    font-size: 13px;
    padding: 0;
    text-decoration: underline;
    margin: 0;
    color: #0084ff;
  }

  .info-tooltip-content {
    position: absolute;
    font-size: 12px;
    font-weight: 400;
    color: #0084ff;
    z-index: 1;
    padding: 5px;
    width: 99%;
    left: -8px;
    top: 19px;
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
}

.progress-bar {
  background-color: #fc8301 !important;
}

.currency-icon {
  width: 35px;
  height: 35px;
  padding: 5px;
}

.paywithcurr {
  border-left: 4px solid #ff7a00;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ededee;
  color: #1b1f3b;
  padding: 10px;
  line-height: 15px;
  height: 100%;
}

.currency-option {
  padding: 5px 10px;
  border-bottom: 1px solid rgba(238, 238, 254, 1);
  margin-top: 2px;
}

.collapse {
  max-height: 150px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: white;
  }

  &::-webkit-scrollbar-thumb {
    background: #ededee;
    border-radius: 8px;
  }

  scrollbar-color: #ededee white;
  scrollbar-width: thin;
}

.cs-payment {
  &__refund_link {
    background-color: #0084ff;
    font-size: 14px;
    padding: 8px 10px;
    margin-top: 20px !important;
    margin: auto;
    width: 130px;
    color: #ffffff !important;
    border-radius: 8px;
    cursor: pointer;
    border: none;

    &:hover {
      box-shadow: 1px 1px 2px #0084ff;
    }
  }

  &__refund_link_desc {
    color: rgb(245, 62, 62);
    font-size: 14px;
    margin-top: 10px;
    display: block;
  }

  &__qr-code-info {
    display: flex;
    border: 1px solid #d7d8d6;
    padding: 12px 8px;
    border-radius: 4px;
    color: #6b7390;
    line-height: 15px;

    span {
      margin-right: 10px;

      img {
        width: 50px;
      }
    }
  }

  &__checking-payment {
    display: flex;
    color: #ff7500;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: center;

    span {
      margin-right: 10px;

      img {
        width: 13px;
        animation: rotation 2s infinite linear;

        @keyframes rotation {
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
  }

  &__partial-payment {
    //display: flex;
    color: #ff7500;
    line-height: 15px;
    padding-top: 10px;
    padding-bottom: 10px;
    position: relative;

    span.wallet-address {
      color: #000000;
    }

    span {
      margin-right: 10px;

      img {
        width: 18px;
      }

      small {
        margin-right: 5px;
      }
    }

    .cs-qrcode {
      width: 140px;
      min-width: 120px;
      height: 140px;
      margin: 10px;
    }

    i {
      margin-top: -7px;
      width: 16px;
    }
  }

  &__payment-processed {
    display: flex;
    color: #42cd69;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #42cd69;
      border-radius: 50%;
      height: 18px;
      width: 18px;
      padding: 2px;
      margin-right: 10px;

      img {
        width: 12px;
      }
    }
  }

  &__error {
    padding-top: 10px;
    padding-bottom: 10px;
    color: rgb(245, 62, 62);
  }
}

.search-wrapper {
  position: relative;
  display: flex;
  width: 160px;

  .search-input {
    width: 100%;
    border: 1px solid #ededee;
    padding: 5px;
    font-size: 14px;
    color: #1b1f3b;

    &::placeholder {
      font-size: 14px;
      color: #ededee;
    }
  }

  .clear-data {
    cursor: pointer;

    img {
      display: inline-block;
      position: absolute;
      width: 8px;
      right: 12px;
      top: 12px;
    }
  }
}

.grid-template {
  display: grid;
  grid-auto-columns: 50%;
  grid-gap: 10px;
  padding: 10px;
  grid-template-columns: 1fr 3fr;
  align-items: center;
}

.loader-gradient {
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, #fca45b, #fcbd8a);
  background-color: #fe9036;
  margin: auto;
  border-radius: 4px;
  background-size: 20%;
  background-repeat: repeat-y;
  background-position: -25% 0;
  animation: scroll 1.2s ease-in-out infinite;

  img {
    // width: 13px;
    animation: rotation 2s infinite linear;

    @keyframes rotation {
      100% {
        transform: rotate(360deg);
      }
    }
  }
}

@keyframes scroll {
  50% {
    background-size: 80%;
  }

  100% {
    background-position: 125% 0;
  }
}

.metaMask {
  padding: 12px;

  &-pay {
    font-weight: 600;
    font-size: 16px;
  }
}

.lightning-icon {
  width: 25px;
  height: 25px;

  img {
    width: inherit;
    height: inherit;
  }
}

.infoText {
  display: flex;
  padding: 7px 8px;
  border-radius: 4px;
  color: #7e7e7e;
  background-color: #f2f2f2;
  line-height: 15px;
  font-size: 13px;
  margin: 14px;

  .divText {
    width: 94%;
  }

  .divimg {
    width: 8%;
  }

  div {
    // margin-right: 4px;
    img {
      width: 25px;
      margin-top: 1px;
      margin-right: 5px;
    }

    ol {
      padding: 0px 10px;
      margin-bottom: 0px;
    }
  }
}

.disable-click {
  pointer-events: none !important;
}

.tooltip {
  .tooltip-inner {
    max-width: 230px;
    padding: 0.25rem 0.5rem;
    color: #fff !important;
    text-align: left;
    background-color: #000000 !important;
    border-radius: 0.25rem;
    font-family: "Mukta", sans-serif;
    font-size: 12px;
    border: 1px solid #000000 !important;
  }
}

.time-label {
  color: black;
  position: absolute;
  left: 39%;
}

.expiry-overlay-box {
  position: relative;
}

.expiry-overlay {
  background: lightgray;
  padding: 10px;
  margin: 0px 20px 0px 10px;
  border-radius: 10px;
  text-align: center;
  color: black;
  position: absolute;
  top: -30px;

  h5 {
    font-size: 15px;
    text-decoration: underline;
  }

  p {
    font-size: 14px;
  }
}

.closebtn {
  width: 13px;
  padding: 3px;
  float: right;
  cursor: pointer;
}

.cs-qrcopybox {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  width: 275px;
  margin: -10px auto auto 10px;
}

.copied-message {
  font-size: 14px;
  max-width: 100%;
  display: block;
}

.font-size-15 {
  font-size: 15px;
  font-weight: 700;
}
</style>
